import { GCRoleType, GCRoleTypeOptions } from '@apply/constants';
import { isMobileScreen } from '@apply/ui';

export interface GeneralContractorRoleProps {
    role: GCRoleType | undefined;
}

export const GeneralContractorRole: React.FC<GeneralContractorRoleProps> = ({ role }) => {
    const mobileScreen = isMobileScreen();
    const roleLabel = () => {
        if (mobileScreen) {
            return GCRoleTypeOptions.find((o) => o.id === role)?.name;
        } else {
            return GCRoleTypeOptions.find((o) => o.id === role)?.shortName;
        }
    };
    return (
        <>
            <div className='manageUsersByUserTable-generalContractor-role'>
                {roleLabel() ?? <div className='manageUsersByUserTable-generalContractor-role-none'>No Role Assigned</div>}
            </div>
        </>
    );
};
